import Constant from '@/common/constant/Constant';

/**
 * 
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationProject 
 * @returns 
 */
export const prepareParamsQueryTicketInviteB2BCustomer = (usage, affiliationOrganization, affiliationProject) => {
    if (!usage) {
        return null;
    }

    let sortKey = `${usage}`;
    const sortKeyArray = [affiliationOrganization,affiliationProject]
    sortKeyArray.forEach(key => {
        sortKey = `${sortKey}#${key}`
    });

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)', 

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#invitationFlag': 'invitationFlag',
            '#dataType': 'dataType',
            '#ticketType': 'ticketType',
            '#public': 'public'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':invitationFlag': {
                N :  `${Constant.INVITATION_FLAG.INVITE_SUCCESS}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
            ':orTicketInvitationGuestProject': {
                N: `${Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT}`
            },
            ':orTicketTypeRequestExternalDesk': {
                N: `${Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK}`
            },
            ':orTicketTypeRequestExternalCustomer': {
                N: `${Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER}`
            },
            ':public': {
                S: Constant.TICKET_PUBLIC.PUBLIC
            },
        },
        FilterExpression: `#public = :public AND #invitationFlag <> :invitationFlag AND #dataType = :dataType AND (
            #ticketType = :orTicketInvitationGuestProject OR
            #ticketType = :orTicketTypeRequestExternalDesk OR
            #ticketType = :orTicketTypeRequestExternalCustomer
        )`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    
    return params;
}
/**
 * 
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationProject 
 * @returns 
 */
export const prepareParamsQueryTicketInviteWaitingB2BCustomerSearch = (usage, affiliationOrganization, affiliationProject) => {
    if (!usage) {
        return null;
    }

    let sortKey = `${usage}`;
    const sortKeyArray = [affiliationOrganization,affiliationProject]
    sortKeyArray.forEach(key => {
        sortKey = `${sortKey}#${key}`
    });

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)', 

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey': 'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#invitationFlag': 'invitationFlag',
            '#dataType': 'dataType',
            '#ticketType': 'ticketType',
            '#liveOrArchived': 'liveOrArchived'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':orinvitationFlagWaiting': {
                N :  `${Constant.INVITATION_FLAG.WAITING_APPROVE}`
            },
            ':orinvitationFlagDefault': {
                N :  `${Constant.INVITATION_FLAG.INPROCESS}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
            ':orTicketTypeRequestExternalDesk': {
                N: `${Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK}`
            },
            ':orTicketTypeRequestExternalCustomer': {
                N: `${Constant.TICKET_TYPE.REQUEST_EXTERNAL_CUSTOMER}`
            },
            ':liveOrArchived': {
                S: `${Constant.LIVE_OR_ARCHIVED.LIVE}`
            }
        },
        FilterExpression: `(#invitationFlag = :orinvitationFlagWaiting OR #invitationFlag = :orinvitationFlagDefault) AND #dataType = :dataType AND (
            #ticketType = :orTicketTypeRequestExternalDesk OR
            #ticketType = :orTicketTypeRequestExternalCustomer
        ) AND #liveOrArchived = :liveOrArchived`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    
    return params;
}

/**
 * prepareParamsQueryTicketListAssignToUser
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationProject 
 * @param {*} userId 
 * @returns 
 */
export const prepareParamsQueryTicketListAssignToUser = (
    usage,
    affiliationOrganization,
    affiliationProject,
    userId
) => {
    if (!usage || !userId) {
        return null;
    }

    let sortKey = `${usage}`;
    if (affiliationOrganization) {
        sortKey = `${sortKey}#${affiliationOrganization}`;
        if (affiliationProject) {
            sortKey = `${sortKey}#${affiliationProject}`;
        }
    }

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#personInCharge': 'personInCharge',
            '#dataType': 'dataType',
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':personInCharge': {
                S: `${userId}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
        },
        FilterExpression: '#dataType = :dataType AND #personInCharge = :personInCharge',
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    return params;
};

export const prepareParamsGetTicketDataGSI3WithFilter = (ticketId, dataType, dataID) => {
    let params = {
        KeyConditionExpression: '#ticketId = :ticketId AND begins_with(#sortKey, :sortKey) ',
        FilterExpression: '#dataID = :dataID',
        ExpressionAttributeNames: {
            '#ticketId': 'ticketId',
            '#sortKey': 'dataType#dataLang',
            '#dataID': 'dataID'
        },
        ExpressionAttributeValues: {
            ':ticketId': {
                S: ticketId
            },
            ':sortKey': {
                S: dataType
            },

            ':dataID': {
                S: dataID
            }
        },
        IndexName: Constant.GSI.TICKET_GSI_3
    };

    return params;
};


/**
 * prepareParamsGetTicketListOfCustomerUser
 * get list ticket of guest customer user
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} userId 
 * @param {*} projectGuestCustomerId 
 * @returns 
 */
export const prepareParamsGetTicketListOfCustomerUser = (
    usage,
    affiliationOrganization,
    affiliationProject,
    userId,
    projectGuestCustomerId
) => {
    if (!usage || !userId || !affiliationOrganization) {
        return null;
    }

    let sortKey = `${usage}`;
    if (affiliationOrganization) {
        sortKey = `${sortKey}#${affiliationOrganization}`;
        if (affiliationProject) {
            sortKey = `${sortKey}#${affiliationProject}`;
        }
    }

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#ticketType': 'ticketType',
            '#customer': 'customer',
            '#public': 'public'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':ticketTypeQA': {
                N: `${Constant.TICKET_TYPE.QA}`
            },
            ':customer': {
                S: `${userId}`
            },
            ':ticketTypeDelegate': {
                N: `${Constant.TICKET_TYPE.DELEGATE}`
            },
            ':ticketTypeNoticeChild': {
                N: `${Constant.TICKET_TYPE.BROADCAST_CHILD}`
            },
            ':projectGuestCustomerId': {
                S: `${projectGuestCustomerId}`
            },
            ':public': {
                S: Constant.TICKET_PUBLIC.PUBLIC
            }
        },
        FilterExpression: `#public = :public AND ((#ticketType = :ticketTypeQA AND #customer = :customer) OR 
            (#ticketType = :ticketTypeDelegate AND #customer = :customer) OR 
            (#ticketType = :ticketTypeNoticeChild AND #customer = :customer) OR 
            (#ticketType = :ticketTypeNoticeChild AND #customer = :projectGuestCustomerId))`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
};


/**
 * prepareParamsGetTicketListBetweenTwoProject
 * @param {*} usage 
 * @param {*} projectOrigin 
 * @param {*} projectTarget 
 * @returns 
 */
export const prepareParamsGetTicketListBetweenTwoProject = (
    usage,
    projectOrigin,
    projectTarget
) => {
    if (!usage || !projectOrigin || !projectTarget) {
        return null;
    }

    let params = {
        KeyConditionExpression: '#usage = :usage',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#public': 'public',
            '#affiliationProject': 'affiliationProject',
            '#customer': 'customer',
            '#dataType': 'dataType',
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':projectOrigin': {
                S: `${projectOrigin}`
            },
            ':projectTarget': {
                S: `${projectTarget}`
            },
            ':public': {
                S: Constant.TICKET_PUBLIC.PUBLIC
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            }
        },
        FilterExpression: `#public = :public AND #dataType = :dataType AND ((#affiliationProject = :projectOrigin AND #customer = :projectTarget) OR (#affiliationProject = :projectTarget AND #customer = :projectOrigin))`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
};


/**
 * prepareParamsGetTicketListCreatedByUser
 * @param {*} usage 
 * @param {*} userId 
 * @returns 
 */
export const prepareParamsGetTicketListCreatedByUser = (
    usage,
    userId
) => {
    if (!usage || !userId) {
        return null;
    }

    let sortKey = `${usage}`;
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#creator': 'creator',
            '#proxiedUser': 'proxiedUser',
            '#dataType': 'dataType',
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':creator': {
                S: `${userId}`
            },
            ':proxiedUser': {
                S: `${userId}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
        },
        FilterExpression: '#dataType = :dataType AND (#creator = :creator OR #proxiedUser = :proxiedUser)',
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    return params;
};


/**
 * prepareParamsGetAllTicketInCustomerAndHelpdeskSide
 * @param {*} usage 
 * @param {*} userId 
 * @param {*} projectId 
 * @returns 
 */
export const prepareParamsGetAllTicketInCustomerAndHelpdeskSide = (
    usage,
    userId,
    projectId
) => {
    if (!usage || !userId || !projectId) {
        return null;
    }

    let sortKey = `${usage}`;
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#customer': 'customer',
            '#affiliationProject': 'affiliationProject',
            '#dataType': 'dataType',
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
            ':userId': {
                S: `${userId}`
            },
            ':projectId': {
                S: `${projectId}`
            }
        },
        FilterExpression: '#dataType = :dataType AND (#customer = :userId OR #customer = :projectId OR #affiliationProject = :projectId)',
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    return params;
};


export const prepareParamsGetAllTicketHelpdeskSide = (
    usage,
    affiliationOrganization,
    affiliationProject
) => {

    let sortKey = `${usage}#${affiliationOrganization}#${affiliationProject}`;
    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#dataType': 'dataType',
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
        },
        FilterExpression: '#dataType = :dataType',
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    return params;
};

export const prepareParamsGetAllTicketCustomerSide = (customer) => {
    let params = {
        KeyConditionExpression: '#customer = :customer',

        ExpressionAttributeNames: {
            "#customer": "customer",
            '#dataType': 'dataType'
        },
        ExpressionAttributeValues: {
            ":customer": {
                "S": customer
            },
            ':dataType': {
                S: `${Constant.TICKET_DATA_TYPE.TICKET}`
            },
        },
        FilterExpression: '#dataType = :dataType',
        IndexName: Constant.GSI.TICKET_GSI_2
    };
    return params;
};


/**
 * prepareParamsGetAllTicketBetweenHelpdeskAndCustomerProject
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} affiliationProject 
 * @param {*} customer 
 * @returns 
 */
export const prepareParamsGetAllTicketBetweenHelpdeskAndCustomerProject = (
    usage,
    affiliationOrganization,
    affiliationProject,
    customer
) => {
    if (!usage || !affiliationOrganization || !affiliationProject || !customer) {
        return null;
    }

    let sortKey = `${usage}#${affiliationOrganization}#${affiliationProject}`;

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#public': 'public',
            '#dataType': 'dataType',
            '#customer': 'customer'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':public': {
                S: Constant.TICKET_PUBLIC.PUBLIC
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            },
            ':customer': {
                S: customer
            }
        },
        FilterExpression: `#public = :public AND #dataType = :dataType AND #customer = :customer`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
};


/**
 * prepareParamsGetTicketListToArchivedAfterDeleteUser
 * @param {*} usage 
 * @param {*} affiliationOrganization 
 * @param {*} userId 
 * @param {*} projectBaseId 
 * @returns 
 */
export const prepareParamsGetTicketListToArchivedAfterDeleteUser = (
    usage,
    affiliationOrganization,
    userId,
    projectBaseId
) => {
    if (!usage || !userId || !affiliationOrganization || !projectBaseId) {
        return null;
    }

    let sortKey = `${usage}`;
    if (affiliationOrganization) {
        sortKey = `${sortKey}#${affiliationOrganization}`;
    }

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            '#usage': 'usage',
            '#sortKey':
                'usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt',
            '#ticketType': 'ticketType',
            '#projectOrigin': 'projectOrigin',
            '#customer': 'customer',
            '#public': 'public',
            '#liveOrArchived': 'liveOrArchived',
            '#dataType': 'dataType'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: usage
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ':ticketTypeQAInternal': {
                N: `${Constant.TICKET_TYPE.INTERNAL_QA}`
            },
            ':projectBaseId': {
                S: `${projectBaseId}`
            },
            ':userId': {
                S: `${userId}`
            },
            ':ticketTypeDelegate': {
                N: `${Constant.TICKET_TYPE.DELEGATE}`
            },
            ':ticketTypeNoticeParent': {
                N: `${Constant.TICKET_TYPE.BROADCAST_PARENT}`
            },
            ':ticketTypeNoticeChild': {
                N: `${Constant.TICKET_TYPE.BROADCAST_CHILD}`
            },
            ':public': {
                S: Constant.TICKET_PUBLIC.PUBLIC
            },
            ':liveOrArchived': {
                S: Constant.LIVE_OR_ARCHIVED.LIVE
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            }
        },
        FilterExpression: `#dataType = :dataType AND #public = :public AND #liveOrArchived = :liveOrArchived AND (
            (#ticketType = :ticketTypeQAInternal AND #customer = :userId AND #projectOrigin = :projectBaseId) OR 
            (#ticketType = :ticketTypeDelegate AND #customer = :userId) OR 
            (#ticketType = :ticketTypeNoticeParent AND #customer = :userId) OR 
            (#ticketType = :ticketTypeNoticeChild AND #customer = :userId)
        )`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };
    
    return params;
};

export const prepareParamsGetActiveHelpdeskTicketList = (affiliationOrganization, affiliationProject) => {
    const sortKey = `${Constant.TICKET_USAGE.REQ}#${affiliationOrganization}#${affiliationProject}`;

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            "#usage": "usage",
            "#sortKey": "usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt",
            "#liveOrArchived": "liveOrArchived",
            "#public": "public",
            '#dataType': 'dataType'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: Constant.TICKET_USAGE.REQ
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ":liveOrArchived_eq": {
                "S": Constant.LIVE_OR_ARCHIVED.LIVE
            },
            ":public_eq": {
                "S": Constant.TICKET_PUBLIC.PUBLIC
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            }
        },
        FilterExpression: `#dataType = :dataType AND #liveOrArchived = :liveOrArchived_eq AND #public = :public_eq`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
}

export const prepareParamsGetActiveHelpdeskTaskTicketList = (affiliationOrganization, affiliationProject) => {
    const sortKey = `${Constant.TICKET_USAGE.TASK}#${affiliationOrganization}#${affiliationProject}`;

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            "#usage": "usage",
            "#sortKey": "usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt",
            "#liveOrArchived": "liveOrArchived",
            "#public": "public",
            '#dataType': 'dataType'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: Constant.TICKET_USAGE.TASK
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ":liveOrArchived_eq": {
                "S": Constant.LIVE_OR_ARCHIVED.LIVE
            },
            ":public_eq": {
                "S": Constant.TICKET_PUBLIC.PUBLIC
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            }
        },
        FilterExpression: `#dataType = :dataType AND #liveOrArchived = :liveOrArchived_eq AND #public = :public_eq`,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
}


/**
 * prepareParamsQueryTicketByGSI3
 * @param {*} ticketId 
 * @param {*} dataType 
 * @param {*} dataLang 
 * @returns 
 */
export const prepareParamsQueryTicketByGSI3 = (ticketId, dataType, dataLang) => {
    if (!ticketId) return;
    let sortKey = '';
    if (dataType) {
        sortKey = `${dataType}`;
        if (dataLang) {
            sortKey = `${sortKey}#${dataLang}`;
        }
    }

    let params = {
        KeyConditionExpression: '#ticketId = :ticketId',

        ExpressionAttributeNames: {
            "#ticketId": "ticketId"
        },
        ExpressionAttributeValues: {
            ':ticketId': {
                S: ticketId
            }
        },
        
        IndexName: Constant.GSI.TICKET_GSI_3
    };

    if (sortKey) {
        params.KeyConditionExpression = `${params.KeyConditionExpression} AND begins_with(#sortKey, :sortKey)`;
        params.ExpressionAttributeNames['#sortKey'] = 'dataType#dataLang';
        params.ExpressionAttributeValues[':sortKey'] = {
            S: sortKey
        }
    }

    return params;
}

export const prepareParamsListMasterKnowledgeTicketOfForm = (affiliationOrganization, affiliationProject,formId) => {
    const sortKey = `${Constant.TICKET_USAGE.KNOWLEDGE}#${affiliationOrganization}#${affiliationProject}`;

    let params = {
        KeyConditionExpression: '#usage = :usage AND begins_with(#sortKey, :sortKey)',

        ExpressionAttributeNames: {
            "#usage": "usage",
            "#sortKey": "usage#affiliationOrganization#affiliationProject#readPermission#liveOrArchived#createdAt",
            "#ticketType": "ticketType",
            "#formId": "formId",
            '#knowledgeFormId': 'formId',
            '#dataType': 'dataType'
        },
        ExpressionAttributeValues: {
            ':usage': {
                S: Constant.TICKET_USAGE.KNOWLEDGE
            },
            ':sortKey': {
                S: `${sortKey}`
            },
            ":ticketType": {
                N: `${Constant.TICKET_TYPE.MASTER_KNOWLEDGE}`
            },
            ':dataType': {
                S: Constant.TICKET_DATA_TYPE.TICKET
            },
            ':formId':{
                S: `${formId}`
            }
        },
        FilterExpression: `#dataType = :dataType AND #ticketType = :ticketType AND #formId.#knowledgeFormId = :formId `,
        IndexName: Constant.GSI.TICKET_GSI_1
    };

    return params;
}